// store/modalSlice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ModalState {
  visible: boolean;
  title: string;
  content: string | React.ReactNode;
  onOk?: () => void;
  onCancel?: () => void;
  className?: string;
  maskClosable: boolean;
}

const initialState: ModalState = {
  visible: false,
  title: '',
  content: '',
  onOk: undefined,
  onCancel: undefined,
  className: '',
  maskClosable: true,
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state, action: PayloadAction<ModalState>) => {
      state.visible = true;
      state.title = action.payload.title;
      state.content = action.payload.content;
      state.onOk = action.payload.onOk;
      state.onCancel = action.payload.onCancel;
      state.className = action.payload.className;
      state.maskClosable = action.payload.maskClosable;
    },
    hideModal: (state) => {
      state.visible = false;
    },
  },
});

export const { showModal, hideModal } = modalSlice.actions;
